import { matchPath } from 'react-router-dom';

export const scrollToTop = (behavior = 'smooth' as ScrollBehavior) =>
  setTimeout(() => window.scrollTo({ top: 0, behavior }), 10);

export const checkPath = (pathname: string, path: string): boolean =>
  Boolean(matchPath(pathname, { path, exact: true, strict: true }));
